import React, { SVGProps } from 'react';

export const CancelIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 18,
  height = 18,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 18 18"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 0C4.02975 0 0 4.02975 0 9C0 13.9703 4.02975 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM13.4516 11.8609L11.8609 13.4516L9 10.5907L6.13912 13.4516L4.54838 11.8609L7.40925 9L4.54838 6.13912L6.13912 4.54838L9 7.40925L11.8609 4.54838L13.4516 6.13912L10.5907 9L13.4516 11.8609Z"
        fill="#CD1A28"
      />
    </svg>
  );
};
